module.exports = __webpack_public_path__ + "static/media/review_icon.2f1fdfbf.svg";